import React from 'react'
import AdminMenu from '../components/AdminMenu'; // ajusta la ruta si estás en una subcarpeta


function AdminFavoritos() {
  return (
    <div>
      <h2>Favoritos del Administrador</h2>
    </div>
  )
}

export default AdminFavoritos
